import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyInquiryOrder from './index.vue';

var AddInquiryOrderPage = function (_super) {
  __extends(AddInquiryOrderPage, _super);

  function AddInquiryOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddInquiryOrderPage = __decorate([Component({
    components: {
      AddEditCopyInquiryOrder: AddEditCopyInquiryOrder
    }
  })], AddInquiryOrderPage);
  return AddInquiryOrderPage;
}(Vue);

export default AddInquiryOrderPage;